import {
  Button,
  Flex,
  AlertDescription,
  AlertIcon,
  Alert,
} from "@chakra-ui/react";
import { useCallback } from "react";

export const OutdatedAlert = () => {
  const handleRefresh = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <Alert mb={4} status="warning">
      <Flex align="center" justify="space-between" w="100%">
        <Flex>
          <AlertIcon />
          <AlertDescription>
            This dashboard has been updated. You are viewing an outdated
            version.
          </AlertDescription>
        </Flex>
        <Button colorScheme="blue" onClick={handleRefresh} size="sm">
          Refresh
        </Button>
      </Flex>
    </Alert>
  );
};
